import { z } from "zod";

import { documentAssetSchema } from "./assets";
import { pdfToDocxOptionsSchema } from "./capabilities";

export const jobStatusSchema = z.enum([
  "CREATED",
  "QUEUED",
  "INSPECTING",
  "CONVERTING",
  "VALIDATING",
  "SUCCEEDED",
  "FAILED",
  "CANCELED",
]);

export type JobStatus = z.infer<typeof jobStatusSchema>;

export const jobStageSchema = z.enum([
  "CREATED",
  "QUEUED",
  "INSPECTING_INPUT",
  "SELECTING_ENGINE",
  "CONVERTING",
  "VALIDATING_OUTPUT",
  "COMPLETED",
]);

export type JobStage = z.infer<typeof jobStageSchema>;

export const createJobRequestSchema = z
  .object({
    capability: z.literal("pdf.to.docx"),
    inputAssetIds: z.array(z.string().min(1)).length(1),
    options: pdfToDocxOptionsSchema.default({
      ocr: "auto",
      language: "auto",
      layoutMode: "preserve-layout",
    }),
  })
  .strict();

export type CreateJobRequest = z.infer<typeof createJobRequestSchema>;

export const createJobResponseSchema = z.object({
  jobId: z.string().min(1),
  status: z.literal("QUEUED"),
});

export type CreateJobResponse = z.infer<typeof createJobResponseSchema>;

export const processingJobSchema = z.object({
  id: z.string().min(1),
  capability: z.literal("pdf.to.docx"),
  capabilityVersion: z.string().min(1),
  status: jobStatusSchema,
  stage: jobStageSchema,
  progress: z.number().int().min(0).max(100),
  options: pdfToDocxOptionsSchema,
  selectedEngine: z.string().nullable(),
  outputAssetId: z.string().nullable(),
  errorCode: z.string().nullable(),
  errorDetail: z.string().nullable(),
  workflowInstanceId: z.string().nullable(),
  createdAt: z.string().datetime(),
  startedAt: z.string().datetime().nullable(),
  completedAt: z.string().datetime().nullable(),
  expiresAt: z.string().datetime(),
  inputAssets: z.array(documentAssetSchema),
  outputAsset: documentAssetSchema.nullable(),
});

export type ProcessingJobDto = z.infer<typeof processingJobSchema>;

export const getJobResponseSchema = z.object({ job: processingJobSchema });
export type GetJobResponse = z.infer<typeof getJobResponseSchema>;
